import { render, staticRenderFns } from "./DkColorPicker.vue?vue&type=template&id=0d178248&"
import script from "./DkColorPicker.vue?vue&type=script&lang=js&"
export * from "./DkColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports